import { ChangeEvent, FC, ReactNode } from 'react'
import {
  DefaultFormContainer,
  FormItemTitle,
  ContainerWithLeftBar,
  AddressOptions,
  FormInputErrorMessage
} from './styles'
import OptionButton from '../../basic/OptionButton'
import { LeftBar } from '../../../components/basic/LeftBar';
import StandardInput from '../../../components/basic/StandardInput';
import { ValidationErrorMessage } from 'src/components/basic/ValidationErrorMessage/ValidationErrorMessage';

interface OptionTextProps {
  title: ReactNode;
  textHint?: string;
  textHintElement?: ReactNode
  showOptions?: boolean;
  text?: string;
  setText: (text: string | undefined) => void;
  selectedOption?: boolean;
  setSelectedOption?: (option: boolean) => void;
  isIncorrect?: boolean;
  errorCodes?: string[];
}

const OptionText: FC<OptionTextProps> = ({
  title,
  textHint,
  textHintElement,
  showOptions,
  text,
  setText,
  selectedOption,
  setSelectedOption,
  isIncorrect,
  errorCodes = [],
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setText(value)
  }

  const handleOptionButton = (option: boolean) => {
    if (!!setSelectedOption) {
      setSelectedOption(option)
      if(!option) {
        setText('')
      }
    }
  }

  return (
    <DefaultFormContainer>
      <FormItemTitle>{title}</FormItemTitle>
      {showOptions ? (
        <>
          <AddressOptions>
            <OptionButton
              checked={selectedOption === true}
              onChange={() => handleOptionButton(true)}
              isIncorrect={isIncorrect && showOptions && (selectedOption === undefined || selectedOption === null)}
              errorCode={errorCodes[0]}
            >
              Yes
            </OptionButton>
            <OptionButton
              checked={selectedOption === false}
              onChange={() => handleOptionButton(false)}
              isIncorrect={isIncorrect && showOptions && (selectedOption === undefined || selectedOption === null)}
              errorCode={errorCodes[0]}
            >
              No
            </OptionButton>
          </AddressOptions>
          <ValidationErrorMessage errorCode={errorCodes[0]} />
          {isIncorrect && (selectedOption === undefined || selectedOption === null) ? (
            <FormInputErrorMessage>
              This is a required field
            </FormInputErrorMessage>
          ) : null}
        </>
      ) : null}
      {(!showOptions || (showOptions === true && selectedOption === true)) ? (
        <ContainerWithLeftBar maxWidth='490px'>
          <LeftBar />
          <div className='content'>
            <StandardInput
              label={textHintElement ? textHintElement : textHint ?? ""}
              name="text"
              onChange={handleChange}
              value={text ?? ''}
              rows={6}
              isIncorrect={isIncorrect}
              errorMessage={isIncorrect ? 'This is a required field' : ''}
              errorCode={errorCodes[1]}
            />
          </div>
        </ContainerWithLeftBar>
      ) : null}
    </DefaultFormContainer>
  )
}

export default OptionText